import {
  Box,
  Button,
  HStack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  useColorModeValue,
  Flex
} from '@chakra-ui/react';
import Card from 'components/Card/Card';
import { useEffect, useState } from 'react';
import FilaController from './controllers/FilaController';

function FilaView() {
  const [filaTranscricao, setFilaTranscricao] = useState([]);
  const [filaLLM, setFilaLLM] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalTranscriptQueue, setTotalTranscriptQueue] = useState(0);
  const textColor = useColorModeValue('gray.700', 'white');

  const fetchData = async () => {
    try {
      const jwtToken = localStorage.getItem('access_token');
      const transcricaoData = await FilaController.ListMasterQueue(jwtToken);
      const llmData = await FilaController.listFilaLLM(jwtToken);
      const totalTranscriptionQueue = await FilaController.listTotalTranscriptions(jwtToken);
      setFilaTranscricao(transcricaoData);
      setFilaLLM(llmData);
      setTotalTranscriptQueue(totalTranscriptionQueue[0].qtd_transcriptions_queue);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRefresh = () => {
    setLoading(true);
    fetchData();
  };

  return (
    <Flex direction="column" height="100%" width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <VStack align="stretch" spacing={4} p={5}>
          <HStack justifyContent="space-between">
            <Text fontWeight="bold" color={textColor} fontSize="xl">
              Fila de Transcrição e Questões
            </Text>
            <Button onClick={handleRefresh} colorScheme="blue" isLoading={loading}>
              Atualizar
            </Button>
          </HStack>
          <Box borderWidth="1px" borderRadius="lg" overflow="hidden" p={4}>
            <HStack justifyContent="space-between">
              <Text fontWeight="bold" color={textColor}>
                Fila
              </Text>
              <Text fontWeight="bold" color={textColor}>
                Total da Fila: {totalTranscriptQueue}
              </Text>
            </HStack>
            <Table variant="striped" colorScheme="blue.900" mt={4}>
              <Thead>
                <Tr>
                  <Th>Nome do Arquivo</Th>
                  <Th>Status Transcrição</Th>
                  <Th>Status Ficha</Th>
                  <Th>Perguntas Respondidas</Th>
                  <Th>Data</Th>
                </Tr>
              </Thead>
              <Tbody>
                {filaTranscricao.map((transcricao, index) => (
                  <Tr key={index} bg={index % 2 === 0 ? '#dddcdc1f' : 'transparent'}>
                    <Td>{transcricao.file_name}</Td>
                    <Td>{transcricao.status_transcription_queue}</Td>
                    <Td>{transcricao.status_gpt_queue}</Td>
                    <Td>{transcricao.quantity_answer}</Td>
                    <Td>{transcricao.date_inserted}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        </VStack>
      </Card>
    </Flex>
  );
}

export default FilaView;